import React from 'react';
import PropTypes from 'prop-types';
import { is, has, both, equals } from 'ramda';
import { Grid, Row, Col } from 'react-flexbox-grid';

import Dialog from 'material-ui/Dialog';
import Paper from 'material-ui/Paper';
import { TextFieldBoxNoForm } from 'components/TextFieldBox';
import IconButton from 'material-ui/IconButton';
import Back from 'material-ui/svg-icons/navigation/arrow-back';

import RefreshIndicator from 'material-ui/CircularProgress';
import VirtualList from 'react-tiny-virtual-list';

import {
  tableRow,
  tableCell,
  selected,
  cellName,
  cellDetail,
  contentStyle,
  bodyStyle,
  paperStyle,
  searchBar,
  textInput,
} from './MedicationSearchDialog.less';

const isSelected = (selection, vnr) => both(is(Object), has('vnr'))(selection) && equals(vnr, selection.vnr);

const loadingIndicator = () => (
  <RefreshIndicator
    color={'048b82'}
    size={20}
    status="loading"
    thickness={3}
    style={{ display: 'block', position: 'relative', float: 'right', margin: '7px 10px 0 -30px' }}
  />
);

const backArrow = onClose => (
  <IconButton onClick={onClose}>
    <Back />
  </IconButton>
);

const isLoading = load => (load ? loadingIndicator() : false);

const MobileDialog = ({
  open,
  selection,
  results,
  onSearch,
  onSelect,
  onChoose,
  onClose,
  localeMessage,
  resultsLoad,
  viewPortSize,
}) => (
  <Dialog
    title={false}
    open={open}
    contentClassName={contentStyle}
    bodyClassName={bodyStyle}
    paperClassName={paperStyle}
    autoDetectWindowHeight={false}
    autoScrollBodyContent
    modal
  >
    <Grid fluid style={{ padding: '0' }}>
      <Row className={searchBar} middle="xs">
        <Col xs={2}>
          <Row center="xs">
            <Col xs>{backArrow(onClose)}</Col>
          </Row>
        </Col>
        <Col xs={9} className={textInput} style={{ paddingLeft: '0' }}>
          <TextFieldBoxNoForm
            hintLocale={localeMessage('medication.dialog.search')}
            onChange={e => onSearch(e.target.value)}
            viewStyle={{ width: '100%', margin: '0' }}
          />
          {isLoading(resultsLoad)}
        </Col>
      </Row>
      <Row style={{ padding: '0', margin: '0' }}>
        <Col xs style={{ padding: '0' }}>
          <Paper>
            <VirtualList
              width="100%"
              // TODO: Move this to some configurable place.
              // If the height for the bar is now changed, this will have to be changed too.
              height={viewPortSize.height * 0.1 > 50 ? viewPortSize.height * 0.9 : viewPortSize.height - 50}
              itemCount={results.length}
              itemSize={75}
              renderItem={({ index, style }) => (
                <Row
                  key={results[index].medIndex}
                  middle="xs"
                  className={`${tableRow} ${isSelected(selection, results[index].vnr) ? selected : ''}`}
                  style={{ ...style, margin: '0' }}
                  onClick={() => {
                    onSelect(index);
                    setTimeout(() => {
                      onChoose();
                    }, 500);
                  }}
                >
                  <Col className={tableCell} xs={12}>
                    <Row>
                      <p className={cellName}>{results[index].name}</p>
                    </Row>
                    <Row>
                      <p className={cellDetail}>{results[index].dosageForm}</p>
                    </Row>
                    <Row>
                      <p className={cellDetail}>{results[index].substanceString}</p>
                    </Row>
                  </Col>
                </Row>
              )}
            />
          </Paper>
        </Col>
      </Row>
    </Grid>
  </Dialog>
);

MobileDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onSearch: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  onChoose: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  localeMessage: PropTypes.func.isRequired,
  results: PropTypes.array,
  selection: PropTypes.object,
  resultsLoad: PropTypes.bool.isRequired,
  viewPortSize: PropTypes.object,
};

export default MobileDialog;
